import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { useTracking } from "react-tracking";
import { catalogSectionCleanSearchText, catalogSectionStartDelete, cleanCatalogSectionLevel1, cleanCatalogSectionLevel2, cleanSearchingCatalogSectionsPaginated, selectCatalogSectionLevel1, selectCatalogSectionLevel2, selectCatalogSections, startLoadingCatalogSectionByParent, startLoadingCatalogSectionsByLevel1, startLoadingCatalogSectionsNoLevel6, startLoadingCatalogSectionsPaginated, startSearchingCatalogSectionsPaginated } from "../../app/actions/catalogSectionActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import NavbarIconsCatalogSections from "../generic-nav-bar/NavbarIconsCatalogSections";
import SearchBackCatalogSection from "../generic-search/SearchBackCatalogSection";
import ReactPaginateComponent from "../generic-ui/ReactPaginateComponent";
import SimpleSelect from "../generic-ui/Select";
import TableCatalogSections from "./TableCatalogSections";

const ID_FORM = "admin-section";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListCatalogSections = () => {
  debugLogPages(':: ListCatalogSections'); 

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, catalogSectionsS, catalogSectionsP, totalPagesP, totalPagesS, currentPageS,
    listCatalogSectionsLevel1, listCatalogSectionsLevel2
  } = useSelector((state) => state.catalogSection);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");
  const [catalogSectionLevel1, setCatalogSectionLevel1] = useState("");
  const [catalogSectionLevel2, setCatalogSectionLevel2] = useState("");
  const [isDisabledSearchText, setIsDisabledSearchText] = useState(false);
  const [isDisabledFilter, setIsDisabledFilter] = useState(false);

  useEffect(() => {
    //First Clean list and searchText
    dispatch(cleanSearchingCatalogSectionsPaginated());
    dispatch(catalogSectionCleanSearchText());
    //Load Data
    
    dispatch(startLoadingCatalogSectionsPaginated(pageInitial, itemsPerPage));
    setSearchText("");

    dispatch(startLoadingCatalogSectionsNoLevel6())
    
    dispatch(startLoadingCatalogSectionsByLevel1(1));
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditCatalogSections", method: "onEditRow", event: "EditCatalogSections-Clicked" });

    dispatch(selectCatalogSections(row));
    if (catalogSectionsS?.length > 0) {
      navigate("/admin-section/edit-section", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-section/edit-section");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteCatalogSections", method: "onDeleteRow", event: "DeleteCatalogSections-Clicked" });
    dispatch(catalogSectionStartDelete(row.id));
  };

  const onPageChangeReactPaginate = (pageClick) => {
    const pageClickRP = pageClick && pageClick.selected + 1

    if (catalogSectionsS && catalogSectionsS.length > 0) {
      dispatch(startSearchingCatalogSectionsPaginated(searchText, pageClickRP - 1, itemsPerPage));
    } else {
      dispatch(startLoadingCatalogSectionsPaginated(pageClickRP - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (catalogSectionsS && catalogSectionsS.length > 0) {
      dispatch(startSearchingCatalogSectionsPaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingCatalogSectionsPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  const handleChangeSectionLevel1 = (event) => {
    
    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);

      
      if (event.code === 0) {

        setCatalogSectionLevel1(event);

        dispatch(cleanCatalogSectionLevel1());

        dispatch(selectCatalogSectionLevel1(event));

        setCatalogSectionLevel2("");

      } else {

        setCatalogSectionLevel1(event);

        dispatch(cleanCatalogSectionLevel1());

        dispatch(selectCatalogSectionLevel1(event));

        setCatalogSectionLevel2("");

        dispatch(startLoadingCatalogSectionsPaginated(pageInitial, itemsPerPage, event));

        dispatch(startLoadingCatalogSectionByParent(event.id, 2));
      }
    } else {

      setIsDisabledSearchText(false);
      setIsDisabledFilter(false);


      dispatch(cleanCatalogSectionLevel1());
      setCatalogSectionLevel1("");
      setCatalogSectionLevel2("");

      dispatch(startLoadingCatalogSectionsPaginated(pageInitial, itemsPerPage));

    }
  };

  const handleChangeSectionLevel2 = (event) => {

    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);



      setCatalogSectionLevel2(event);

      dispatch(cleanCatalogSectionLevel2());

      dispatch(selectCatalogSectionLevel2(event));

      dispatch(startLoadingCatalogSectionsPaginated(pageInitial, itemsPerPage, event));

      dispatch(startLoadingCatalogSectionByParent(event.id, 3));
    } else {

      //setIsDisabledSearchText(false);
      setIsDisabledFilter(false);


      dispatch(cleanCatalogSectionLevel2());
      setCatalogSectionLevel2("");

      dispatch(startLoadingCatalogSectionsPaginated(pageInitial, itemsPerPage, catalogSectionLevel1));

    }
  };


  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  return (
    <>
      <NavbarIconsCatalogSections page={"listCatalogSections"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="container">
        <div className="row">

          {/* catalogSectionId */}
          {/* Level1 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level1`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangeSectionLevel1}
                classNamePrefix="select"
                name="catalogSectionLevel1"
                value={catalogSectionLevel1}
                options={listCatalogSectionsLevel1}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />
            </div>
          </div>

          {/* Level2 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level2`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangeSectionLevel2}
                classNamePrefix="select"
                name="catalogSectionLevel2"
                value={catalogSectionLevel2}
                options={listCatalogSectionsLevel2}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />

            </div>
          </div>

        </div>
      </div>

      <hr className="line-hr" />

      <SearchBackCatalogSection 
        searchText={searchText} 
        setSearchText={setSearchText} 
        itemsPerPage={itemsPerPage} 
        setIsDisabledSearchText={setIsDisabledSearchText}
        isDisabledSearchText={isDisabledSearchText}
        setIsDisabledFilter={setIsDisabledFilter}
        isDisabledFilter={isDisabledFilter}
        />

      {catalogSectionsS && catalogSectionsS.length > 0 ? (
        <TableCatalogSections data={catalogSectionsS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableCatalogSections data={catalogSectionsP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <SimpleSelect listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {catalogSectionsS && catalogSectionsS.length > 0 ? (
          <ReactPaginateComponent
            totalPages={totalPagesS}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChangeReactPaginate}
            currentPage={currentPageS}
            marginPagesDisplayed={5}
          />
        ) : (
          <ReactPaginateComponent
            totalPages={totalPagesP}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChangeReactPaginate}
            currentPage={currentPageS}
            marginPagesDisplayed={5}
          />
        )}
      </div>
    </>
  );
};

export default ListCatalogSections;
